"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

require("./AlloText.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AlloText(_ref) {
  var brand = _ref.brand,
      user = _ref.user,
      integration = _ref.integration,
      custom = _ref.custom,
      handleEnd = _ref.handleEnd,
      language = _ref.language,
      color = _ref.color,
      env = _ref.env,
      maxTime = _ref.maxTime,
      filename = _ref.filename;
  var mainDiv = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isSending = _useState2[0],
      setIsSending = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      text = _useState4[0],
      setText = _useState4[1];

  var manageSending = function manageSending() {
    localStorage.stage = env || "";
    setIsSending(true);
    var fetching = new Promise(function (res) {
      return fetch('https://bdcgo3u5t6.execute-api.eu-west-2.amazonaws.com/prod/', {
        method: 'POST',
        body: JSON.stringify({
          "text": text
        })
      }).then(function (resp) {
        if (!resp.ok) {
          res({
            text: text,
            sentiment: 'NEUTRAL',
            language: 'fr'
          });
        }

        return resp.json();
      }).then(function (resp) {
        //console.log(resp)
        res({
          text: text,
          sentiment: resp['sentiment'],
          language: resp['language']
        });
      });
    });
    fetching.then(function (resp) {
      var element = mainDiv.current;
      element.style.transform = 'scale(0)';
      element.style.opacity = '0';
      handleEnd((0, _objectSpread2.default)((0, _objectSpread2.default)({}, resp), {}, {
        'file_id': (0, _utils.sendFeedback)(resp, brand, user, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, integration), custom), filename)
      }));
    }).catch(function () {
      return setIsSending(true);
    });
  };

  (0, _react.useEffect)(function () {
    var element = mainDiv.current;

    var _iterator = (0, _createForOfIteratorHelper2.default)(element.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;

        if (child.tagName === 'TEXTAREA') {
          child.style.height = child.clientWidth * 1 / 2 + 'px';
        }

        if (child.className === 'button') {
          child.style.backgroundColor = color;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "AlloText",
    ref: mainDiv
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    placeholder: (0, _utils.getLanguage)({
      "en": "Write your feedback here ...",
      "fr": "Écrivez votre commentaire ici ..."
    }),
    onChange: function onChange(v) {
      return setText(v.target.value);
    },
    value: text
  }), function () {
    return !isSending ? /*#__PURE__*/_react.default.createElement("p", {
      className: "button",
      key: "1",
      onClick: manageSending
    }, (0, _utils.getLanguage)({
      "en": "Send",
      "fr": "Envoyer"
    })) : /*#__PURE__*/_react.default.createElement("p", {
      key: "2"
    }, (0, _utils.getLanguage)({
      "en": "Sending in progress ...",
      "fr": "Envoi en cours ..."
    }));
  }());
}

var _default = AlloText;
exports.default = _default;